import React from 'react';
import Header from 'gatsby-theme-carbon/src/components/Header';

const CustomHeader = (props) => (
  <Header {...props}>
    Instana&nbsp;<span>Thinklab 1201</span>
  </Header>
);

export default CustomHeader;
